import LegalLayout from "@/components/LegalLayout";
import { LAST_UPDATED } from "@/constants/site";

const PrivacyPolicy = () => (
  <LegalLayout
    title="Privacy Policy"
    updated={LAST_UPDATED}
    intro="Swarajya Solar Services ('we', 'our', 'us') respects your privacy. This policy explains what information we collect when you call us or submit a quote request on this website, how we use it, and the choices you have."
    sections={[
      {
        heading: "Information We Collect",
        body: [
          "When you submit a quote request or contact us, we collect the details you choose to share:",
        ],
        list: [
          "Your name and phone number",
          "Your city or village, when provided",
          "Property type and monthly electricity bill range, when provided",
          "Any message you write to us",
          "Call details when you contact us by phone",
        ],
      },
      {
        heading: "How We Use Your Information",
        body: [
          "We use your information for one purpose only: responding to your enquiry and serving you as a customer. Specifically, we use it to call you back about your quote request, schedule a free site survey, prepare quotations, and provide installation and after-sales support.",
          "We do not sell, rent or trade your personal information to any third party for marketing purposes.",
        ],
      },
      {
        heading: "Sharing of Information",
        body: [
          "We share your details only where it is necessary to complete your work: with equipment suppliers and service partners involved in your installation, and with government bodies or the electricity distribution company (DISCOM) where required for subsidy applications and net metering. We may also disclose information if required by law.",
        ],
      },
      {
        heading: "Data Security",
        body: [
          "We store your details securely and limit access to team members who need it to serve you. We retain enquiry information only as long as needed to respond to your request and to maintain our business records.",
        ],
      },
      {
        heading: "Cookies & Analytics",
        body: [
          "This website may use standard analytics tools to understand how visitors use the site (for example, which pages are visited). These tools may set cookies in your browser. You can disable cookies in your browser settings; the site will continue to work.",
        ],
      },
      {
        heading: "Your Rights",
        body: [
          "You may ask us at any time to confirm what details we hold about you, correct them, or delete them. To do so, call us or raise it when we return your call, and we will act on it promptly.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any questions about this privacy policy, call us at 98341 78018 during working hours (Mon – Sat, 8 AM – 8 PM).",
        ],
      },
    ]}
  />
);

export default PrivacyPolicy;
